import { lmsClient } from "api";

const BankAccountService = {};

BankAccountService.getBankAccounts = function(data) {
    const params = new URLSearchParams();

    if (data?.branchId) params.append("branchId", data.branchId);
    if (data?.bankAccountType) params.append("bankAccountType", data.bankAccountType);
    if (data?.accountPurpose) params.append("accountPurpose", data.accountPurpose);
    if (data?.sortName) params.append("sortName", data.sortName);
    if (data?.status) params.append("status", data.status);
    if (data?.isVirtualAccount) params.append("isVirtualAccount", data.isVirtualAccount);
    if (data?.isEbanking) params.append("isEbanking", data.isEbanking);

    return lmsClient({
        url: `/lookups/bank-accounts?${params.toString()}`,
        method: "get"
    })
};

BankAccountService.getBankAccountsByBranch = function(branchId) {
    return lmsClient({
        url: `/lm_bank_account/branch/${branchId}`,
        method: "get"
    });
};

BankAccountService.getBankAccountsByBranchAndPurpose = function(branchId, bankPurpose) {
    return lmsClient({
        url: `/lm_bank_account/branch/${branchId}/purpose/${bankPurpose}`,
        method: "get"
    });
};


BankAccountService.searchBankAccounts = function (data = {}) {
  const params = new URLSearchParams();
  params.append("bankaccountid", data.bankaccountid || "");
  params.append("bankaccountname", data.bankaccountname || "");
  params.append("accountNo", data.norekening ?? data.accountNo ?? "");
  params.append("branchId", data.branchid ?? data.branchId ?? "");
  params.append("bankPurpose", data.bankPurpose ?? data.bankPurpose ?? "");
  params.append("pageIndex", data.pageIndex ?? 0);
  params.append("pageSize", data.pageSize ?? 10);

  return lmsClient({
    url: `/lms/lm_bank_account/search?${params.toString()}`,
    method: "get",
  });
};

export default BankAccountService;